import React from 'react';
import Iframe from 'react-iframe';

const Contact = () => {
  return (
    <div>
      <div className="pt-16 mb-10">
        <h2 className="text-center text-main text-6xl">Contact US</h2>
      </div>
      <div className="container mx-auto bg-gray-50 mb-10">
        <div className="p-12">
          <div className="grid md:grid-cols-2 gap-10">
            <div className="border bg-white p-5">
              <h2 className="text2xl font-bold">General Information</h2>
              <p>B-17, Old DLF Colony </p>
              <p>Near Sector-14, M.G. Road</p>
              <p>Gurugram-122001, Haryana, India</p>
              <p>Phone: +91 9910091720</p>
              <p>Email: drpriyankayadavdermatologist@gmail.com</p>
            </div>
            {/* <div className="border bg-white p-5">
              <h2 className="text2xl font-bold">Patient Experience</h2>
              <p>Hannah Harper - Patient Experience Coordinator</p>
              <p>Phone: +91 9910091720</p>
              <p>Email: abcd@gmail.com</p>
            </div> */}
            <div className="border bg-white p-5">
              <h2 className="text2xl font-bold">Working Hours</h2>
              <p>Monday – Friday : 8:00 AM - 8:00 PM</p>
              <p>Saturday : 10:00 AM - 6:00 PM</p>
              <p>Sunday : 10:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-center text-main text-6xl">Google Map</h2>
      <div className="border md:w-4/5 mx-auto p-10 my-10 shadow">
        <Iframe
          className="shadow-lg"
          url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1730.8887336096716!2d77.04347881555239!3d28.47119798354665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19b28d5ffd61%3A0xb3f673865dceaabd!2sDerma%20Pera%20Skin%20Beyond!5e0!3m2!1sen!2sin!4v1678875970387!5m2!1sen!2sin"
          width="100%"
          height="400px"
        ></Iframe>
      </div>
    </div>
  );
};

export default Contact;
